import TymberAPIConfig from "./config";
import {makeJsonAPIPayload, v1, v2, v4} from "./utils";

const Endpoints = {
  v1: {
    create: () => v1("carts/"),
    cart: (uuid) => v1(`carts/${uuid}/`),
    cartItems: (uuid) => v1(`carts/${uuid}/items/`),
    cartItem: (cartId, itemId) => v1(`carts/${cartId}/items/${itemId}/`),
    validate: (uuid) => v1(`carts/${uuid}/valid/`),
  },
  v2: {
    create: () => v2("carts/"),
    cart: (uuid) => v2(`carts/${uuid}/`),
    cartItems: (uuid) => v2(`carts/${uuid}/items/`),
    cartItem: (cartId, itemId) => v2(`carts/${cartId}/items/${itemId}/`),
    validate: (uuid) => v2(`carts/${uuid}/valid/`),
  },
  v4: {
    create: () => v4("carts/"),
    cart: (uuid) => v4(`carts/${uuid}/`),
    cartItems: (uuid) => v4(`carts/${uuid}/items/`),
    cartItem: (cartId, itemId) => v4(`carts/${cartId}/items/${itemId}/`),
    validate: (uuid) => v4(`carts/${uuid}/valid/`),
  },
};

export function show(uuid) {
  const axios = TymberAPIConfig.axios();
  return axios.get(Endpoints.v1.cart(uuid)).then((response) => response.data);
}

export function deleteItem(uuid, {id}) {
  const axios = TymberAPIConfig.axios();
  return axios.delete(Endpoints.v1.cartItem(uuid, id)).then((response) => response.data);
}

export function create({id, quantity, delivery_specification, inventory_type, ...rest}) {
  const axios = TymberAPIConfig.axios();
  const jsonApiPayload = makeJsonAPIPayload("carts", {
    delivery_specification,
    inventory_type,
    item: {
      quantity: quantity,
      product_id: id,
      ...rest,
    },
  });
  const version = getAPIVersion(TymberAPIConfig.ordersEndpointV4);
  return axios.post(version.create(), jsonApiPayload).then((response) => response.data);
}

export function validate(cart, attrs = {}) {
  const axios = TymberAPIConfig.axios();
  const jsonApiPayload = makeJsonAPIPayload(
    "carts",
    makePayload(cart, {
      reward_id: cart.getReward(),
      ...attrs,
    })
  );
  const version = getAPIVersion(TymberAPIConfig.ordersEndpointV4);
  return axios
    .post(version.validate(cart.getId()), jsonApiPayload)
    .then((response) => response.data);
}

export function update(cart, attrs = {}) {
  const axios = TymberAPIConfig.axios();
  const jsonApiPayload = makeJsonAPIPayload(
    "carts",
    makePayload(cart, {
      reward_id: cart.getReward(),
      ...attrs,
    }),
    undefined,
    cart.getId()
  );
  const version = getAPIVersion(TymberAPIConfig.ordersEndpointV4);
  return axios
    .put(version.cart(cart.getId()), jsonApiPayload)
    .then((response) => response.data);
}

function makePayload(cart, attributes) {
  if (TymberAPIConfig.ordersEndpointV4) {
    attributes.promo_codes = cart.getPromoCodes();
  } else {
    attributes.promo_code = cart.getPromoCode();
  }
  return attributes;
}

export function updateItem(cartId, itemId, {id, quantity, ...rest}) {
  const axios = TymberAPIConfig.axios();
  const jsonApiPayload = makeJsonAPIPayload(
    "cart_items",
    {
      quantity: quantity,
      product_id: id,
      ...rest,
    },
    undefined,
    itemId
  );
  const version = getAPIVersion(TymberAPIConfig.ordersEndpointV4);
  return axios
    .patch(version.cartItem(cartId, itemId), jsonApiPayload)
    .then((response) => response.data);
}

export function addItem(uuid, {id, quantity, ...rest}, config = {}) {
  const axios = TymberAPIConfig.axios();
  const jsonApiPayload = makeJsonAPIPayload("cart_items", {
    quantity: quantity,
    product_id: id,
    ...rest,
  });
  const version = getAPIVersion(TymberAPIConfig.ordersEndpointV4);
  return axios
    .post(version.cartItems(uuid), jsonApiPayload, config)
    .then((response) => response.data);
}

const getAPIVersion = (useV4) => {
  if (useV4) {
    return Endpoints.v4;
  } else {
    return Endpoints.v2;
  }
};
